const inntauingSitePaths = {
  shortUrl: "/inntauing",
  ileggelser: {
    shortUrl: "/inntauing/ileggelser",
    detalj: {
      shortUrl: "/inntauing/ileggelser/:id",
    },
  },
};

export default inntauingSitePaths;
